import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import moment from 'config/Moment';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as InterviewsActions } from 'store/ducks/interviews';

import { Validate } from 'common';
import { Page, Panel, Button, Loading } from 'components';
import { Form } from 'pages/Admin/Interviews/components';

class Create extends Component {
  state = {
    data: {
      course: '',
      course_class: '',
      calculated_at: null,
      journey: '',
      person: '',
      coach_email: null,
      blind_participant: false
    },
    errors: {},
  };

  handleChange = data => {
    this.handleValidate();
    this.setState({ data });
  };

  handleValidate = () => {
    const { data } = this.state;

    if (data.coach_email === '') {
      data.coach_email = null;
    }

    const rules = {
      course: {
        required: true,
      },

      course_class: {
        required: true,
      },

      calculated_at: {
        required: true,
      },

      journey: {
        required: true,
      },

      person: {
        required: true,
      },

      coach_email: {
        email: true
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSubmit = e => {
    e.preventDefault();

    if (!this.handleValidate()) return null;

    const { data } = this.state;

    this.props.createInterviewRequest({
      person_id: data.person.value,
      interviewable_type: data.journey.value.type,
      interviewable_id: data.journey.value.key,
      course: data.course,
      course_class: data.course_class,
      calculated_at: moment(data.calculated_at).format('YYYY-MM-DD HH:mm'),
      coach_email: data.coach_email,
      blind_participant: !data.blind_participant,
    });
  };

  render() {
    const { data, errors } = this.state;
    const { create } = this.props;

    return (
      <Page>
        <div className="row align-items-center">
          <div className="col-6">
            <Page.Title>Nova Entrevista</Page.Title>
          </div>

          <div className="col-6 text-right">
            <Button type="success" onClick={this.handleSubmit} disabled={create.loading}>
              {create.loading ? <Loading type="btn" size="small" text="Salvando..." /> : 'Salvar'}
            </Button>

            <Link to="/admin/interviews" className="btn btn-danger m-l-10">
              Cancelar
            </Link>
          </div>
        </div>

        <Panel>
          <Form data={data} errors={errors} onChange={this.handleChange} onSubmit={this.handleSubmit} />
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  create: state.interviews.create,
});

const mapActions = dispatch => bindActionCreators(InterviewsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Create);



// WEBPACK FOOTER //
// ./src/pages/Admin/Interviews/Create/index.js